export const enumPermisosMoviliza = Object.freeze({
  pago: 13000
});



